module.exports = __webpack_public_path__ + "static/fipcrosebunnymain-e203d587ab497b17fb6f3f187d2dc95f.jpeg";